import { render, staticRenderFns } from "./OxygenBorderRadiusInput.vue?vue&type=template&id=07947be6&scoped=true&"
import script from "./OxygenBorderRadiusInput.vue?vue&type=script&lang=ts&"
export * from "./OxygenBorderRadiusInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07947be6",
  null
  
)

export default component.exports